import type {
  ReactElement,
} from 'react';

import type {
  ContainerComponentProps,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

export function Container({
  rootProps: {
    payload,
  },
  children,
}: ContainerComponentProps<PaginatorPayload>): ReactElement {
  return (
    <div
      id={payload?.wrapperId}
    >
      {children}
    </div>
  );
}
